
// @ts-nocheck


export const localeCodes =  [
  "ar",
  "de",
  "en",
  "es",
  "hi",
  "ne",
  "pt",
  "ru",
  "tr",
  "ur",
  "vi"
]

export const localeLoaders = {
  ar: [
    {
      key: "locale_ar_46json_659619b4",
      load: () => import("#nuxt-i18n/659619b4" /* webpackChunkName: "locale_ar_46json_659619b4" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_ef828841",
      load: () => import("#nuxt-i18n/ef828841" /* webpackChunkName: "locale_de_46json_ef828841" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_cb4b506c",
      load: () => import("#nuxt-i18n/cb4b506c" /* webpackChunkName: "locale_en_46json_cb4b506c" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_0f943852",
      load: () => import("#nuxt-i18n/0f943852" /* webpackChunkName: "locale_es_46json_0f943852" */),
      cache: true
    }
  ],
  hi: [
    {
      key: "locale_hi_46json_53dc21a4",
      load: () => import("#nuxt-i18n/53dc21a4" /* webpackChunkName: "locale_hi_46json_53dc21a4" */),
      cache: true
    }
  ],
  ne: [
    {
      key: "locale_ne_46json_b09fe408",
      load: () => import("#nuxt-i18n/b09fe408" /* webpackChunkName: "locale_ne_46json_b09fe408" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_6737623e",
      load: () => import("#nuxt-i18n/6737623e" /* webpackChunkName: "locale_pt_46json_6737623e" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_3a247a8e",
      load: () => import("#nuxt-i18n/3a247a8e" /* webpackChunkName: "locale_ru_46json_3a247a8e" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_20a3a988",
      load: () => import("#nuxt-i18n/20a3a988" /* webpackChunkName: "locale_tr_46json_20a3a988" */),
      cache: true
    }
  ],
  ur: [
    {
      key: "locale_ur_46json_4b9adab2",
      load: () => import("#nuxt-i18n/4b9adab2" /* webpackChunkName: "locale_ur_46json_4b9adab2" */),
      cache: true
    }
  ],
  vi: [
    {
      key: "locale_vi_46json_228a729d",
      load: () => import("#nuxt-i18n/228a729d" /* webpackChunkName: "locale_vi_46json_228a729d" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "ar",
      language: "ar-SA",
      name: "arabic",
      dir: "rtl",
      _hreflang: "ar-SA",
      _sitemap: "ar-SA",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/ar.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de-DE",
      name: "german",
      _hreflang: "de-DE",
      _sitemap: "de-DE",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en-US",
      name: "english",
      _hreflang: "en-US",
      _sitemap: "en-US",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      name: "spanish",
      _hreflang: "es-ES",
      _sitemap: "es-ES",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hi",
      language: "hi-IN",
      name: "hindi",
      _hreflang: "hi-IN",
      _sitemap: "hi-IN",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/hi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ne",
      language: "ne-NP",
      name: "nepali",
      _hreflang: "ne-NP",
      _sitemap: "ne-NP",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/ne.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      language: "pt-PT",
      name: "portuguese",
      _hreflang: "pt-PT",
      _sitemap: "pt-PT",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/pt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      language: "ru-RU",
      name: "russian",
      _hreflang: "ru-RU",
      _sitemap: "ru-RU",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      language: "tr-TR",
      name: "turkish",
      _hreflang: "tr-TR",
      _sitemap: "tr-TR",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/tr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ur",
      language: "ur-PK",
      name: "urdu",
      dir: "rtl",
      _hreflang: "ur-PK",
      _sitemap: "ur-PK",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/ur.json",
          cache: undefined
        }
      ]
    },
    {
      code: "vi",
      language: "vi-VN",
      name: "vietnamese",
      _hreflang: "vi-VN",
      _sitemap: "vi-VN",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/vi.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://cobe1.com",
  customRoutes: "config",
  pages: {
    login: {
      tr: "/giris",
      en: "/login",
      ar: "/تسجيل-الدخول",
      hi: "/लॉगिन",
      ur: "/لاگ-ان",
      vi: "/dang-nhap",
      ru: "/войти",
      de: "/anmeldung",
      es: "/iniciar-sesion",
      pt: "/entrar",
      ne: "/लगइन"
    },
    register: {
      tr: "/kayit",
      en: "/register",
      ar: "/تسجيل",
      hi: "/पंजीकरण",
      ur: "/رجسٹر",
      vi: "/dang-ky",
      ru: "/регистрация",
      de: "/registrierung",
      es: "/registro",
      pt: "/registro",
      ne: "/दर्ता"
    },
    "partnership-registration": {
      tr: "/is-ortakligi-kaydi",
      en: "/partnership-registration",
      ar: "/تسجيل-شراكة",
      hi: "/साझेदारी-पंजीकरण",
      ur: "/شراکت-رجسٹریشن",
      vi: "/dang-ky-doi-tac",
      ru: "/регистрация-партнерства",
      de: "/partnerschafts-registrierung",
      es: "/registro-de-sociedad",
      pt: "/registro-de-parceria",
      ne: "/साझेदारी-दर्ता"
    },
    "forgot-password": {
      tr: "/sifremi-unuttum",
      en: "/forgot-password",
      ar: "/استعادة-كلمة-المرور",
      hi: "/पासवर्ड-भूल-गए",
      ur: "/پاسورڈ-بھول-گئے",
      vi: "/quen-mat-khau",
      ru: "/восстановить-пароль",
      de: "/passwort-vergessen",
      es: "/recuperar-contrasena",
      pt: "/recuperar-senha",
      ne: "/पासवर्ड-बिर्सनु"
    },
    "reset-password": {
      tr: "/sifre-sifirlama",
      en: "/reset-password",
      ar: "/اعادة-تعيين-كلمة-المرور",
      hi: "/पासवर्ड-रीसेट",
      ur: "/پاسورڈ-ری-سیٹ",
      vi: "/dat-lai-mat-khau",
      ru: "/сброс-пароля",
      de: "/passwort-zurucksetzen",
      es: "/restablecer-contrasena",
      pt: "/redefinir-senha",
      ne: "/पासवर्ड-रीसेट"
    },
    "verify-email": {
      tr: "/email-dogrulama",
      en: "/verify-email",
      ar: "/تأكيد-البريد-الالكتروني",
      hi: "/ईमेल-सत्यापन",
      ur: "/ایمیل-تصدیق",
      vi: "/xac-thuc-email",
      ru: "/подтвердить-email",
      de: "/email-verifizieren",
      es: "/verificar-correo",
      pt: "/verificar-email",
      ne: "/इमेल-पुष्टि"
    },
    "update-verify-email": {
      tr: "/email-guncelleme-dogrulama",
      en: "/update-verify-email",
      ar: "/تحديث-تأكيد-البريد",
      hi: "/ईमेल-अपडेट-सत्यापन",
      ur: "/ایمیل-اپڈیٹ-تصدیق",
      vi: "/cap-nhat-xac-thuc-email",
      ru: "/обновить-подтверждение-email",
      de: "/email-aktualisierung-bestatigen",
      es: "/actualizar-verificacion-correo",
      pt: "/atualizar-verificacao-email",
      ne: "/इमेल-अपडेट-पुष्टि"
    },
    error: {
      tr: "/hata",
      en: "/error",
      ar: "/خطأ",
      hi: "/त्रुटि",
      ur: "/خرابی",
      vi: "/loi",
      ru: "/ошибка",
      de: "/fehler",
      es: "/error",
      pt: "/erro",
      ne: "/त्रुटि"
    },
    index: {
      tr: "/",
      en: "/",
      ar: "/",
      hi: "/",
      ur: "/",
      vi: "/",
      ru: "/",
      de: "/",
      es: "/",
      pt: "/",
      ne: "/"
    },
    chat: {
      tr: "/sohbet",
      en: "/chat",
      ar: "/محادثة",
      hi: "/चैट",
      ur: "/گپ شپ",
      vi: "/tro-chuyen",
      ru: "/чат",
      de: "/chat",
      es: "/charla",
      pt: "/bate-papo",
      ne: "/च्याट"
    },
    "chat-profession": {
      tr: "/sohbet/[profession]",
      en: "/chat/[profession]",
      ar: "/محادثة/[profession]",
      hi: "/चैट/[profession]",
      ur: "/گپ شپ/[profession]",
      vi: "/tro-chuyen/[profession]",
      ru: "/чат/[profession]",
      de: "/chat/[profession]",
      es: "/charla/[profession]",
      pt: "/bate-papo/[profession]",
      ne: "/च्याट/[profession]"
    },
    "chat-profession-conversationId": {
      tr: "/sohbet/[profession]/[conversationId]",
      en: "/chat/[profession]/[conversationId]",
      ar: "/محادثة/[profession]/[conversationId]",
      hi: "/चैट/[profession]/[conversationId]",
      ur: "/گپ شپ/[profession]/[conversationId]",
      vi: "/tro-chuyen/[profession]/[conversationId]",
      ru: "/чат/[profession]/[conversationId]",
      de: "/chat/[profession]/[conversationId]",
      es: "/charla/[profession]/[conversationId]",
      pt: "/bate-papo/[profession]/[conversationId]",
      ne: "/च्याट/[profession]/[conversationId]"
    },
    profession: {
      tr: "/[profession]",
      en: "/[profession]",
      ar: "/[profession]",
      hi: "/[profession]",
      ur: "/[profession]",
      vi: "/[profession]",
      ru: "/[profession]",
      de: "/[profession]",
      es: "/[profession]",
      pt: "/[profession]",
      ne: "/[profession]"
    },
    "profession-country": {
      tr: "/[profession]/[country]",
      en: "/[profession]/[country]",
      ar: "/[profession]/[country]",
      hi: "/[profession]/[country]",
      ur: "/[profession]/[country]",
      vi: "/[profession]/[country]",
      ru: "/[profession]/[country]",
      de: "/[profession]/[country]",
      es: "/[profession]/[country]",
      pt: "/[profession]/[country]",
      ne: "/[profession]/[country]"
    },
    terms: {
      tr: "/kullanim-sartlari",
      en: "/terms",
      ar: "/الشروط",
      hi: "/नियम-और-शर्तें",
      ur: "/شرائط-و-ضوابط",
      vi: "/dieu-khoan",
      ru: "/условия",
      de: "/nutzungsbedingungen",
      es: "/terminos",
      pt: "/termos",
      ne: "/नियम-र-शर्त"
    },
    privacy: {
      tr: "/gizlilik-politikasi",
      en: "/privacy",
      ar: "/الخصوصية",
      hi: "/गोपनीयता",
      ur: "/رازداری",
      vi: "/bao-mat",
      ru: "/конфиденциальность",
      de: "/datenschutz",
      es: "/privacidad",
      pt: "/privacidade",
      ne: "/गोपनीयता"
    },
    cookies: {
      tr: "/cerezler",
      en: "/cookies",
      ar: "/الكوكيز",
      hi: "/कुकीज़",
      ur: "/کوکیز",
      vi: "/cookie",
      ru: "/куки",
      de: "/cookies",
      es: "/cookies",
      pt: "/cookies",
      ne: "/कुकीज"
    },
    pricing: {
      tr: "/fiyatlandirma",
      en: "/pricing",
      ar: "/التسعير",
      hi: "/मूल्य-निर्धारण",
      ur: "/قیمتوں-کا-تعین",
      vi: "/bang-gia",
      ru: "/цены",
      de: "/preise",
      es: "/precios",
      pt: "/precos",
      ne: "/मूल्य"
    },
    contact: {
      tr: "/iletişim",
      en: "/contact-us",
      ar: "/اتصال",
      hi: "/संपर्क",
      ur: "/تماس",
      vi: "/lien-hep",
      ru: "/контакты",
      de: "/kontakt",
      es: "/contacto",
      pt: "/contato",
      ne: "/संपर्क"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  fallbackLocale: "en",
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "ar",
    language: "ar-SA",
    name: "arabic",
    dir: "rtl",
    _hreflang: "ar-SA",
    _sitemap: "ar-SA",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/ar.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de-DE",
    name: "german",
    _hreflang: "de-DE",
    _sitemap: "de-DE",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "english",
    _hreflang: "en-US",
    _sitemap: "en-US",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    name: "spanish",
    _hreflang: "es-ES",
    _sitemap: "es-ES",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hi",
    language: "hi-IN",
    name: "hindi",
    _hreflang: "hi-IN",
    _sitemap: "hi-IN",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/hi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ne",
    language: "ne-NP",
    name: "nepali",
    _hreflang: "ne-NP",
    _sitemap: "ne-NP",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/ne.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    language: "pt-PT",
    name: "portuguese",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    language: "ru-RU",
    name: "russian",
    _hreflang: "ru-RU",
    _sitemap: "ru-RU",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    language: "tr-TR",
    name: "turkish",
    _hreflang: "tr-TR",
    _sitemap: "tr-TR",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/tr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ur",
    language: "ur-PK",
    name: "urdu",
    dir: "rtl",
    _hreflang: "ur-PK",
    _sitemap: "ur-PK",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/ur.json",
        cache: undefined
      }
    ]
  },
  {
    code: "vi",
    language: "vi-VN",
    name: "vietnamese",
    _hreflang: "vi-VN",
    _sitemap: "vi-VN",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/vi.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/